import React, { Component } from 'react';
import styled from 'styled-components';
import SectionTitle from '../../components/SectionTitle';
import Card from '../../components/GeneralCard';

const Section = styled.section`
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  margin-top: 2rem;

  .titleContainer {
    margin-bottom: 2rem;
  }
`;

const Container = styled.div`
  width: 80%;
  min-height: 700px;
  margin: 0 auto;
`;
const WrapperFlex = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 1rem;
  padding: 4em 0;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;
const Box = styled.div`
  width: ${(props) => (props.width ? props.width : '100%')};
  padding: ${(props) => (props.padding ? props.padding : '')};
  margin: ${(props) => (props.margin ? props.margin : '')};
`;

class MainSection extends Component {
  render() {
    const { similarPosts } = this.props;

    return (
      <Section>
        <Container>
          <div className="titleContainer">
            <SectionTitle>Você também vai gostar..</SectionTitle>
          </div>
          <WrapperFlex>
            <Box>
              <Card
                blogPostTheme
                equalHeight={true}
                link={similarPosts[0].slug}
                SrcImageTop={similarPosts[0].cover}
                ImageAltText={similarPosts[0].title}
                SubTitleLeftText={similarPosts[0].date}
                SubTitleRightText={similarPosts[0].category}
                Title={similarPosts[0].title}
                Description={similarPosts[0].description}
              />
            </Box>
            <Box>
              <Card
                blogPostTheme
                equalHeight={true}
                link={similarPosts[1].slug}
                SrcImageTop={similarPosts[1].cover}
                ImageAltText={similarPosts[1].title}
                SubTitleLeftText={similarPosts[1].date}
                SubTitleRightText={similarPosts[1].category}
                Title={similarPosts[1].title}
                Description={similarPosts[1].description}
              />
            </Box>
            <Box>
              <Card
                blogPostTheme
                equalHeight={true}
                link={similarPosts[2].slug}
                SrcImageTop={similarPosts[2].cover}
                ImageAltText={similarPosts[2].title}
                SubTitleLeftText={similarPosts[2].date}
                SubTitleRightText={similarPosts[2].category}
                Title={similarPosts[2].title}
                Description={similarPosts[2].description}
              />
            </Box>
          </WrapperFlex>
        </Container>
      </Section>
    );
  }
}

export default MainSection;
